export default {
  data() {
    return {
      hasSuccess: false,
      hasError: false
    }
  },
  mounted() {
    const serial = document.querySelector(
      '.draft-order-serial-allocation-feedback'
    )
    if (serial) {
      this.hasSuccess = true
      this.enterSuccess()
    }
    const paymentError = document.querySelector('.draft-order-payment-feedback')
    if (paymentError) {
      this.hasError = true
      this.enterError()
    }
  },
  methods: {
    enterSuccess() {
      setTimeout(() => {
        this.hasSuccess = false
      }, 3000)
    },
    enterError() {
      setTimeout(() => {
        this.hasError = false
      }, 3000)
    }
  }
}
